<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="label">车辆维修</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')"></i>
      </div>
      <div class="desc">承租人需到指定维修服务站点进行维修，如擅自维修需支付违约金。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
      <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <div class="flex-row">
        <el-form-item :prop="`${propPrefix}.otherFixFee`" class="flex-input single" style="margin-bottom: 0;" :rules="getRules(10000)">
          <el-input
              :value="modelValue.otherFixFee"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('otherFixFee', $event)"
            >
              <template slot="append">元/次</template>
            </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
